import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const sortAttributes = (attributes: Array<CreationAttribute>) => {
    return attributes.toSorted((firstAttribute, secondAttribute) => {
        if (firstAttribute.deprecated === secondAttribute.deprecated) {
            return firstAttribute.name.localeCompare(secondAttribute.name);
        }

        return firstAttribute.deprecated ? 1 : -1;
    });
};
